import React from 'react'
import classNames from 'classnames'
import {useEnvironment} from '@wix/yoshi-flow-editor'
import {MyAgendaButton} from '../my-agenda-button'
import {Login} from '../login'
import {HeaderDivider} from '../../schedule/divider'
import s from './personal-agenda-header.scss'
import {PersonalAgendaHeaderProps} from '.'

export const PersonalAgendaHeader = ({membersAreaInstalled}: PersonalAgendaHeaderProps) => {
  const {isMobile} = useEnvironment()
  return (
    <div className={classNames(s.topControls, {[s.mobile]: isMobile})}>
      <div className={s.topControlsContent}>
        <MyAgendaButton />
        {!membersAreaInstalled ? (
          <div className={s.topControlsLogin}>
            <Login />
          </div>
        ) : null}
      </div>
      <HeaderDivider />
    </div>
  )
}
